/* me-slider.js — rotateur de messages auto-initialisé.
   Custom element <me-cart-slider> : connectedCallback se déclenche à chaque
   injection dans le DOM (y compris quand le tiroir panier est re-rendu via la
   Section Rendering API), donc pas de dépendance à un init global. */
(function () {
  if (customElements.get('me-cart-slider')) return;
  customElements.define('me-cart-slider', class extends HTMLElement {
    connectedCallback() {
      var slides = this.querySelectorAll('.me-cart-slide');
      if (!slides.length) return;
      var i = 0;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === 0); });
      if (slides.length < 2) return;
      var speed = (parseFloat(this.getAttribute('data-speed')) || 4) * 1000;
      var self = this;
      this._timer = setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, speed);
    }
    disconnectedCallback() { if (this._timer) clearInterval(this._timer); }
  });
})();
